import { render, staticRenderFns } from "./RoteirizacaoDestinoPager.vue?vue&type=template&id=5d798a4d&scoped=true&"
import script from "./RoteirizacaoDestinoPager.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoDestinoPager.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoDestinoPager.vue?vue&type=style&index=0&id=5d798a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d798a4d",
  null
  
)

export default component.exports